import { render, staticRenderFns } from "./FacebookShareButton.vue?vue&type=template&id=ec0157c2&scoped=true&"
import script from "./FacebookShareButton.vue?vue&type=script&lang=js&"
export * from "./FacebookShareButton.vue?vue&type=script&lang=js&"
import style0 from "./FacebookShareButton.vue?vue&type=style&index=0&id=ec0157c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0157c2",
  null
  
)

export default component.exports